const styles = (theme) => ({
  header: {
    borderBottom: `1px solid ${theme.color.grey_ed}`,
  },
  layoutContent: {
    padding: theme.spacing(0, 0, 2.5),
  },
  layoutWithButton: {
    padding: theme.spacing(0, 0, 11.75),
  },
  giftDescription: {
    margin: theme.spacing(2, 3.5),
  },
  email: {
    color: theme.color.teal,
  },
});

export default styles;
